import { render, staticRenderFns } from "./StoreTaking.vue?vue&type=template&id=8b94a08e&"
import script from "./StoreTaking.vue?vue&type=script&lang=js&"
export * from "./StoreTaking.vue?vue&type=script&lang=js&"
import style0 from "./StoreTaking.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports